import { addCredits, hasEnough } from '@/features/ai/lib/money'
import { isSelectable } from './paymentMethods'
import type { CreditPackage } from './paymentMethods'

/** Числа отказа `no_credits`: что было на балансе и сколько стоил прогон. */
export interface Deficit {
  balance: string
  required: string
}

/** Порядок витрины задаёт сервер полем `sortOrder`, а не порядок в ответе. */
export const sortPackages = (list: CreditPackage[]): CreditPackage[] =>
  [...list].sort((a, b) => a.sortOrder - b.sortOrder)

/**
 * Первый по `sortOrder` пакет, после покупки которого хватит на упавший прогон.
 * Считается сложением и сравнением ДЕНЕЖНЫХ СТРОК: вычитания в `money.ts` нет и
 * заводить его незачем — «баланс плюс пакет ≥ цены» отвечает на тот же вопрос.
 * Метка только подсказывает: выбор пакета крупнее или мельче остаётся за автором.
 *
 * Невыбираемые пакеты пропускаются: подсказка «хватит на этот прогон» на
 * карточке, которую нечем оплатить, уводила бы автора в тупиковый шаг. Метка
 * следует за «Выбрать» карточки (`isSelectable`), а не за способами оплаты: у RU
 * без почты карточка выбирается, и шаг оплаты ведёт к форме почты — там метка
 * нужна. Признак спрашивается у `isSelectable`, а не считается тут заново.
 */
export const fittingPackageId = (
  list: CreditPackage[],
  deficit: Deficit | null,
  canPayByCard: boolean,
  country: string | null,
): number | null => {
  if (!deficit) return null
  const fit = sortPackages(list).find(
    (pkg) =>
      isSelectable(pkg, canPayByCard, country) &&
      hasEnough(addCredits(deficit.balance, pkg.credits), deficit.required),
  )
  return fit ? fit.id : null
}
